<script setup>
import { defineProps } from 'vue';

const props = defineProps({
    notification: Object
});

const formatDateTime = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  return date.toLocaleString();
};
</script>

<template>
    <div class="notification-item">
        <p class="text-sm text-gray-500 mb-2">{{ formatDateTime(notification?.date) }}</p>
        <div v-html="notification?.text" class="notification-content"></div>
    </div>
</template>

<style scoped>
 :deep(.notification-content ul) {
    list-style-type: disc;
    padding-left: 1.5rem;
    margin-bottom: 1rem;
}

 :deep(.notification-content ol) {
    list-style-type: decimal;
    padding-left: 1.5rem;
    margin-bottom: 1rem;
}

 :deep(.notification-content li) {
    list-style-type: disc;
    margin-bottom: 0.5rem;
    color: #374151; /* text-gray-700 */
}

 :deep(.notification-content p) {
    margin-bottom: 1rem;
    color: #374151; /* text-gray-700 */
}

 :deep(.notification-content a) {
    color: #3b82f6; /* text-blue-500 */
    text-decoration: underline;
}

 :deep(.notification-content a:hover) {
    color: #2563eb; /* text-blue-600 */
}

 :deep(.notification-content blockquote) {
    padding-left: 1rem;
    border-left: 4px solid #d1d5db; /* border-gray-300 */
    color: #6b7280; /* text-gray-600 */
    margin-bottom: 1rem;
    font-style: italic;
}

 :deep(.notification-content strong) {
    font-weight: bold;
    color: #111827; /* text-gray-900 */
}
</style>
